import { createAction } from "@reduxjs/toolkit"
import { REDUCER_PREFIX } from "./slice"

export const createUserRequest = createAction(`${REDUCER_PREFIX}/createUserRequest`)
